import { Avatar, Button, Card, Flex, Grid, Space, Typography } from "antd";
import deliveryServiceTypes from "../../../constants/deliveryServiceTypes";

const { useBreakpoint } = Grid;
const { Text, Title } = Typography;

export default function DeliverySettingsEnableDisableService({ deliveryService, settings, handleEnableDisable }) {
  const screens = useBreakpoint();

  const getLogo = () => {
    let logo = "";

    switch(deliveryService) {
      case "doordash":
        logo = "https://bevz-media.s3.us-west-1.amazonaws.com/doordash-logo.png";
        break;
      case "grubhub":
        logo = "https://bevz-media.s3.us-west-1.amazonaws.com/grubhub-logo.png";
        break;
      case "uberEats":
        logo = "https://bevz-media.s3.us-west-1.amazonaws.com/ubereats.png";
        break;
    }

    return logo;
  };

  return (
    <Card
      style={{
        position: "absolute",
        width: "100%",
        borderRadius: "15px",
        boxShadow: "0 4px 12px rgba(0, 10, 20, 0.08)",
        zIndex: 999
      }}
    >
      <Flex
        justify={screens.md ? "space-between" : undefined}
        align={screens.md ? "end" : "start"}
        vertical={screens.md ? false : true}
        gap={screens.md ? undefined : "large"}
      >
        <Space>
          <Avatar shape="square" size={70} src={getLogo()} />
          <Flex vertical>
            <Title level={2} style={{ margin: 0 }}>{deliveryServiceTypes[deliveryService].capitalFirst}</Title>
            <Text style={{ fontSize: "24px", color: "#515151" }}>Service Enabled</Text>
          </Flex>
        </Space>
        <Button
          color={settings.enabled ? "danger" : "primary"}
          variant="solid"
          size="large"
          block={screens.md ? false : true}
          onClick={handleEnableDisable}
        >
          {settings.enabled ? "DISABLE" : "ENABLE"}
          &nbsp;SERVICE
        </Button>
      </Flex>
    </Card>
  );
};